<script lang="ts">
	import '../app.css';
	import Header from '$lib/components/Global/Header/Header.svelte';
	import Subheader from '$lib/components/Global/Subheader.svelte';
	import Footer from '$lib/components/Global/Footer.svelte';
	import Oops from '$lib/assets/images/icons/404.svg?component';
	import arrowRight from '$lib/assets/images/icons/arrow-right-green.svg';
	import __ from '$lib/stores/TranslationStore';
	import { page } from '$app/stores';
	import { onMount } from 'svelte';

	type MessageMap = {
		[key in 'default' | `${number}` | number]: {
			title: string;
			description: string;
		};
	};

	const messageMap: MessageMap = {
		403: {
			title: $__('Acesso negado.'),
			description: 'A página que procura não pôde ser acedida.'
		},
		404: {
			title: $__('Página não encontrada.'),
			description: $__('A página que procura não existe.')
		},
		503: {
			title: $__('Serviço não disponível'),
			description: $__('A página que procura não se encontra disponível.')
		},
		500: {
			title: $__('Ocorreu algum erro.'),
			description: $__('Tente novamente mais tarde.')
		},
		default: {
			title: $__('Página não encontrada.'),
			description: $__('A página que procura não existe.')
		}
	};
</script>

<svelte:head>
	<link rel="preconnect" href="https://fonts.gstatic.com" crossorigin />
	<link
		rel="preload"
		href="https://fonts.googleapis.com/css2?family=Sora:wght@300;400;600&display=swap"
	/>
	<link
		rel="stylesheet"
		href="https://fonts.googleapis.com/css2?family=Sora:wght@300;400;600&display=swap"
	/>
</svelte:head>

<Header />
<Subheader />
<div class="container mx-auto py-16">
	<div class="flex flex-col items-center justify-center gap-6 py-16">
		<Oops class="h-80" />
		<h2 class="mt-12 text-5xl text-dark">
			{messageMap[$page.status]?.title || messageMap.default.title}
		</h2>
		<p class="text-xl text-dark">
			{messageMap[$page.status]?.description || messageMap.default.description}
		</p>

		<div class="justify- flex flex-col gap-16">
			<a
				href="/"
				class="flex items-center gap-3 text-xs font-semibold uppercase tracking-0.14 text-primary lg:text-lg"
			>
				{$__('Voltar para o início')}
				<img src={arrowRight} alt="voltar" />
			</a>
		</div>
	</div>
</div>
<Footer />
